import axios from 'axios';
import { ElMessage } from 'element-plus';
// import router from '@/router/index';
import AdenLocalStorage from '@/utils/storage.util';
// 拦截器: 蒙版Loading/token/修改配置
class AdenRequest {
    // request实例 => axios的实例
    constructor(config) {
        var _a, _b, _c, _d;
        this.instance = axios.create(config);
        // 全局请求拦截器
        this.instance.interceptors.request.use((config) => {
            // loading/token
            return config;
        }, (err) => {
            return Promise.reject(err);
        });
        // 全局响应拦截器
        this.instance.interceptors.response.use((res) => {
            return res;
        }, (err) => {
            return Promise.reject(err);
        });
        // 针对特定的AdenRequest实例添加拦截器
        this.instance.interceptors.request.use((_a = config.interceptors) === null || _a === void 0 ? void 0 : _a.requestSuccessFn, (_b = config.interceptors) === null || _b === void 0 ? void 0 : _b.requestFailureFn);
        this.instance.interceptors.response.use((_c = config.interceptors) === null || _c === void 0 ? void 0 : _c.responseSuccessFn, (_d = config.interceptors) === null || _d === void 0 ? void 0 : _d.responseFailureFn);
    }
    // 封装网络请求的方法
    request(config) {
        var _a;
        // 单次请求的成功拦截处理
        if ((_a = config.interceptors) === null || _a === void 0 ? void 0 : _a.requestSuccessFn) {
            config = config.interceptors.requestSuccessFn(config);
        }
        // 返回Promise
        return new Promise((resolve, reject) => {
            this.instance
                .request(config)
                .then((res) => {
                var _a;
                if (res.status === 401) {
                    window.location.href = '/login';
                    ElMessage.error('登录失效，请重新登录');
                    AdenLocalStorage.clearAll();
                }
                // 单次响应的成功拦截处理
                if ((_a = config.interceptors) === null || _a === void 0 ? void 0 : _a.responseSuccessFn) {
                    res = config.interceptors.responseSuccessFn(res);
                }
                resolve(res.data);
            })
                .catch((err) => {
                var _a;
                // 单次响应的失败拦截处理
                if ((_a = config.interceptors) === null || _a === void 0 ? void 0 : _a.responseFailureFn) {
                    err = config.interceptors.responseFailureFn(err);
                }
                reject(err); // 通过 reject 返回错误
            });
        });
    }
    get(config) {
        return this.request(Object.assign(Object.assign({}, config), { method: 'GET' }));
    }
    post(config) {
        return this.request(Object.assign(Object.assign({}, config), { method: 'POST' }));
    }
    put(config) {
        return this.request(Object.assign(Object.assign({}, config), { method: 'PUT' }));
    }
    delete(config) {
        return this.request(Object.assign(Object.assign({}, config), { method: 'DELETE' }));
    }
    patch(config) {
        return this.request(Object.assign(Object.assign({}, config), { method: 'PATCH' }));
    }
}
export default AdenRequest;
